define("Manage.LocationAddress.EntryPoint", [
  "SDB.SDBLocations.Model",
  "Profile.Model",
  "Manage.LocationAddress.Model",
  "Utils",
  "Address.Utils",
  "LiveOrder.Model",
], function (
  SDBLocationsModel,
  ProfileModel,
  ManageLocationAddressModel,
  Utils,
  AddressUtilsModule,
  LiveOrderModel
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var Layout = container.getComponent("Layout");

      /** @type {checkoutComponent} */
      var Checkout = container.getComponent("Checkout");

      /** @type {SDB.Locations.Model} */
      var Locations = SDBLocationsModel.getInstance();

      /** @type {Profile.Model} */
      var Profile = ProfileModel.getInstance();
      var profileAddresses = Profile.get("addresses");

      /** @type {Address.Utils} */
      var Address = AddressUtilsModule.getInstance({
        Application: container,
      });
      /** @type {LiveOrder.Model} */
      var LiveOrder = LiveOrderModel.getInstance();

      var env = container.getComponent("Environment");

      var locationChanged = false;
      var shoppingExperienceChanged = false;
      var locationCallBack = function locationCallBack(locations, strLocation) {
        container.getLayout().hideError(); // Remove the previous errors from layout
        // locations === Locations === SDBLocationsModel.getInstance()
        if (Profile.get("isLoggedIn") === "F") return;
        var LocationAddressModel = new ManageLocationAddressModel();
        var location =
          strLocation && typeof strLocation === "string"
            ? JSON.parse(strLocation)
            : strLocation;
        if (!location) return;

        var locationAddress = Address.pickLocationAddress(location);
        var post_data = {
          address: locationAddress,
          locationId: location.internalid,
        };

        LocationAddressModel.save(post_data, {
          success: function success(response) {
            var newAddressData = response.get("newAddress");
            var newAddressId = newAddressData.internalid;

            locations.set("locationAddress", newAddressId, { silent: true });
            Address.updateAddressCollections(newAddressId);
          },
          error: console.error,
          wait: true,
        });
      };

      var onlineCallBack = function onlineCallBack(
        locations,
        shoppingExperience
      ) {
        if (Profile.get("isLoggedIn") == "F") return;
        if (shoppingExperience === "online") {
          var LocationAddressModel = new ManageLocationAddressModel({ id: "" });

          LocationAddressModel.destroy({
            success: function success(emptyModel, attributes) {
              var oldAddressId = attributes.oldAddress;
              if (oldAddressId)
                profileAddresses.remove(oldAddressId, { wait: true });
              locations.unset("locationAddress", { silent: true });
              Address.setShipAddress();
            },
            error: console.error,
            wait: true,
          }).then(function () {
            var change = !locations.get("updateOverviewAddress");
            locations.set("updateOverviewAddress", change);
          });
        }
      };

      var alreadySubscribed = false;
      var subscribeLocationEvents = function subscribeLocationEvents(
        profile,
        isLoggedIn
      ) {
        if (isLoggedIn === "T" && !alreadySubscribed) {
          var location = Locations.getSelectedLocation();

          if (!location) {
            onlineCallBack(Locations, Locations.getShoppingExperience());
            alreadySubscribed = true;
            return;
          }

          var differentLocation;
          if (!LiveOrder.get("addresses").models[0]) differentLocation = true;
          else
            differentLocation =
              location.addrFields.zip !=
              LiveOrder.get("addresses").models[0].attributes.zip;

          if (differentLocation) {
            locationCallBack(Locations, location);
          }

          alreadySubscribed = true;
        }
      };

      var checkLocationStatus = function checkLocationStatus() {
        // on first login and go to checkout no model is being changed, this updates the model for addresses in checkout functionality
        if (
          !Locations.get("location") ||
          !Locations.get("shoppingExperience")
        ) {
          Locations.set("locations", Locations.getLocations());
          Locations.set("location", Locations.getSelectedLocation());
          Locations.set(
            "shoppingExperience",
            Locations.getShoppingExperience()
          );
        }
      };

      Locations.on({
        "change:location": function changeLocation() {
          if (Locations.getShoppingExperience() === "online") return;
          if (
            Backbone.history.location.pathname.indexOf("checkout") !== -1 ||
            Backbone.history.location.pathname.indexOf("my_account") !== -1
          )
            locationChanged = true;
          else locationCallBack(Locations, Locations.getSelectedLocation());
        },
        "change:shoppingExperience": function changeShoppingExperience() {
          if (Locations.getShoppingExperience() !== "online") return;
          if (
            Backbone.history.location.pathname.indexOf("checkout") !== -1 ||
            Backbone.history.location.pathname.indexOf("my_account") !== -1
          )
            shoppingExperienceChanged = true;
          else onlineCallBack(Locations, Locations.getShoppingExperience());
        },
      });
      Locations.on("change:finishedExternal", function () {
        if (locationChanged) {
          locationChanged = false;
          locationCallBack(Locations, Locations.getSelectedLocation());
        } else if (shoppingExperienceChanged) {
          shoppingExperienceChanged = false;
          onlineCallBack(Locations, Locations.getShoppingExperience());
        }
        // var isLoggedIn = Profile.get('isLoggedIn');
        // LiveOrder.save()
        // .then(function () {
        //     subscribeLocationEvents(Profile, isLoggedIn)
        // })
      });

      var isLoggedIn = Profile.get("isLoggedIn");
      if (Utils.isInShopping()) {
        subscribeLocationEvents(Profile, isLoggedIn);
        return;
      }
      var BillingAddress = require("OrderWizard.Module.Address.Billing");
      var ShippingAddress = require("OrderWizard.Module.Address.Shipping");
      if (Checkout) {
        Checkout.on("beforeShowContent", checkLocationStatus);
        Checkout.on("afterShowContent", function () {
          Checkout.getCurrentStep().then(function (step) {
            if (step.url === "billing" || step.url === "review") {
              $('[class*="sdb-locations-view__current-location"]').addClass(
                "disabled"
              );
            } else {
              $('[class*="sdb-locations-view__current-location"]').removeClass(
                "disabled"
              );
            }
          });
        });
        if (
          env.getConfig("checkoutApp.checkoutSteps") &&
          env.getConfig("checkoutApp.checkoutSteps") == "One Page"
        ) {
          ShippingAddress.prototype.getContext = _.wrap(
            ShippingAddress.prototype.getContext,
            function (fn) {
              var context = fn.apply(this, _.toArray(arguments).slice(1));
              context.showTitle = true;
              return context;
            }
          );
        }
        BillingAddress.prototype.getContext = _.wrap(
          BillingAddress.prototype.getContext,
          function (fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));
            if (Locations.get("shoppingExperience") === "instore") {
              context.isSameAsEnabled = false;
              context.isSameAsCheckBoxDisable = true;
              context.isSameAsSelected = false;
            }
            return context;
          }
        );

        LiveOrder.on("change:addresses", function () {
          if (Address._addressId() == LiveOrder.get("billaddress")) {
            LiveOrder.setAddress("billaddress", "", {
              wait: true,
              validate: false,
            });
          }
        });
      }

      ShippingAddress.prototype.getAddressesToShow = _.wrap(
        ShippingAddress.prototype.getAddressesToShow,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          var storeAddress = Address._addressId();
          var isStoreAddress = _.findWhere(context, { id: storeAddress });

          if (isStoreAddress) {
            context = [isStoreAddress];
          }

          return context;
        }
      );
      ShippingAddress.prototype.getContext = _.wrap(
        ShippingAddress.prototype.getContext,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          context.showAddressList = !!(this.getAddressesToShow().length >= 1);
          return context;
        }
      );
      BillingAddress.prototype.getAddressesToShow = _.wrap(
        BillingAddress.prototype.getAddressesToShow,
        function (fn) {
          var context = fn.apply(this, _.toArray(arguments).slice(1));
          // get location address
          // once location is selected then remove the models
          var storeAddress = Address._addressId();
          var isStoreAddress = _.findWhere(context, { id: storeAddress });

          if (isStoreAddress) {
            context = _.without(context, isStoreAddress);
          }

          return context;
        }
      );

      if (Layout) {
        Layout.addToViewContextDefinition(
          "Address.Details.View",
          "showActionButtons",
          "boolean",
          function (context) {
            var locationAddress = Locations.get("locationAddress");

            if (!locationAddress) {
              var customFields = Profile.get("customfields");
              var addressField = _.find(customFields, {
                name: "custentity_sdb_location_address_id",
              });
              locationAddress = addressField.value;
            }

            if (locationAddress === context.internalid) return false;
            return context.showActionButtons;
          }
        );
        Layout.addToViewContextDefinition(
          "Address.Details.View",
          "showEditButton",
          "boolean",
          function () {
            return true;
          }
        );
        if (SC.ENVIRONMENT.SCTouchpoint == "myaccount") {
          Layout.addToViewContextDefinition(
            "Overview.Shipping.View",
            "hideEdit",
            "boolean",
            function (context) {
              var locationAddress = Locations.get("locationAddress");

              if (!locationAddress) {
                var customFields = Profile.get("customfields");
                var addressField = _.find(customFields, {
                  name: "custentity_sdb_location_address_id",
                });
                locationAddress = addressField.value;
              }

              if (locationAddress === context.shippingAddressInternalid)
                return true;
              return false;
            }
          );

          var OverviewShipping = require("Overview.Shipping.View");
          OverviewShipping.prototype.initialize = _.wrap(
            OverviewShipping.prototype.initialize,
            function (fn) {
              fn.apply(this, _.toArray(arguments).slice(1));
              var self = this;
              this.listenTo(
                Locations,
                "change:updateOverviewAddress",
                function () {
                  self.model = undefined;
                  self.render();
                }
              );
            }
          );

          Layout.on("beforeShowContent", checkLocationStatus);
        }
      }
    },
  };
});
